import React, { Fragment, useEffect, useState } from 'react';

import Breadcrumbs from '../../../CommonComponents/Breadcrumbs/Breadcrumbs';

import { CONCEPT, ALL_ITEMS_LINK, NAV_ITEMS } from './constants';
import './HeaderToystory.scss';

export const HeaderToystory = ({ baseImgUrl }) => {
  const [videoId, setVideoId] = useState('sbENhqNWLzw');
  const [videoSrc, setVideoSrc] = useState('');

  const title = 'TOY STORY | OWNDAYS';
  const breadcrumbs = [
    { path: '/sg/en', label: 'Homepage' },
    { path: '/sg/en/news', label: 'News' },
    { path: '#', label: title },
  ];

  useEffect(() => {
    if (window.Fancybox) {
      window.Fancybox.bind("[data-fancybox='etc']", {});
    }
  }, []);

  const updateVideo = () => {
    const mobileVideoId = 'sbENhqNWLzw';
    const desktopVideoId = '3CG_WpIi4ds';
    const isMobile = window.innerWidth <= 768;
    const selectedVideoId = isMobile ? mobileVideoId : desktopVideoId;

    const baseUrl = `https://www.youtube.com/embed/${selectedVideoId}`;
    const queryParams = new URLSearchParams({
      autoplay: 1,
      mute: 1,
      loop: 1,
      controls: 0,
      showinfo: 0,
      playlist: selectedVideoId,
    });

    setVideoId(selectedVideoId);
    setVideoSrc(`${baseUrl}?${queryParams.toString()}`);
  };

  const scrollToSection = id => {
    if (!id) return;

    const elementId = id.startsWith('#') ? id.substring(1) : id;
    const element = document.getElementById(elementId);

    window.location.hash = elementId;

    if (element) {
      const headerOffset = document.querySelector('header')?.offsetHeight || 0;
      const elementTop = element.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementTop - headerOffset,
        behavior: 'smooth',
      });
    }
  };

  const getAnimationHeader = text => {
    return (
      <span>
        {text.split('\n').map((line, lineIndex) => (
          <React.Fragment key={lineIndex}>
            {line.split(' ').map((word, wordIndex) => (
              <span key={wordIndex}>
                {word.split('').map((char, charIndex) => (
                  <span
                    key={charIndex}
                    className="base-toystory__title__animate-typing__text-split"
                    style={{
                      transitionDelay: `${
                        (lineIndex * line.length + wordIndex * word.length + charIndex) * 0.04
                      }s`,
                    }}
                  >
                    {char}
                  </span>
                ))}
                {wordIndex < line.split(' ').length - 1 && (
                  <span
                    className="base-toystory__title__animate-typing__text-split"
                    style={{ transitionDelay: `${(lineIndex * line.length + wordIndex) * 0.04}s` }}
                  >
                    &nbsp;
                  </span>
                )}
              </span>
            ))}
            {lineIndex < text.split('\n').length - 1 && <br />}{' '}
          </React.Fragment>
        ))}
      </span>
    );
  };

  const renderAnimationHeader = text => {
    return (
      <h2
        data-aos
        className="base-toystory__title base-toystory__title__animate-typing"
        data-aos-offset="500"
      >
        {getAnimationHeader(text)}
      </h2>
    );
  };

  useEffect(() => {
    updateVideo();
    window.addEventListener('resize', updateVideo);

    return () => window.removeEventListener('resize', updateVideo);
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      setTimeout(() => {
        scrollToSection(window.location.hash);
      }, 0);
    }
  }, []);

  return (
    <Fragment>
      <Breadcrumbs crumbs={breadcrumbs} />

      <section className="header-toystory__main">
        <div className="header-toystory__main__bg"></div>

        <div className="base-toystory__container header-toystory__main__content">
          <div className="header-toystory__main__characters__layout">
            <img
              alt="characters"
              className="header-toystory__main__characters__main"
              data-aos="zoom-in"
              data-aos-duration="300"
              loading="lazy"
              src={`${baseImgUrl}/main/characters.webp`}
            />

            <img
              alt="planet"
              className="header-toystory__main__characters__planet"
              data-aos="fade-right"
              data-aos-duration="300"
              loading="lazy"
              src={`${baseImgUrl}/main/figure-1.svg`}
            />

            <img
              alt="rocket"
              className="header-toystory__main__characters__rocket"
              data-aos="fade-left"
              data-aos-duration="300"
              loading="lazy"
              src={`${baseImgUrl}/main/figure-2.svg`}
            />

            <img
              alt="star"
              className="header-toystory__main__characters__star"
              data-aos="fade-right"
              data-aos-duration="300"
              loading="lazy"
              src={`${baseImgUrl}/main/figure-3.svg`}
            />

            <img
              alt="mark"
              className="header-toystory__main__characters__mark"
              data-aos="fade-left"
              data-aos-duration="300"
              loading="lazy"
              src={`${baseImgUrl}/main/figure-4.svg`}
            />
          </div>

          <h1 className="header-toystory__main__logo">
            <span>{title}</span>
            <img alt={title} loading="lazy" src={`${baseImgUrl}/main/logo.svg`} />
          </h1>
        </div>
      </section>

      <section className="header-toystory__concept">
        <div className="header-toystory__concept__cloud__layout">
          <picture>
            <source media="(min-width: 1024px)" srcSet={`${baseImgUrl}/concept/cloud_pc.webp`} />
            <source media="(min-width: 431px)" srcSet={`${baseImgUrl}/concept/cloud_tb.webp`} />
            <img
              alt="CONCEPT"
              className="header-toystory__concept__cloud__bg"
              src={`${baseImgUrl}/concept/cloud_sp.webp`}
            />
          </picture>

          <div className="header-toystory__concept__text">
            {renderAnimationHeader('CONCEPT')}

            <p className="header-toystory__concept__detail" data-aos="fade-up" data-aos-delay="800">
              {CONCEPT.desc}
            </p>

            <a className="base-toystory__btn--primary" href={ALL_ITEMS_LINK}>
              <span>ALL ITEMS</span>
            </a>
          </div>
        </div>

        <div className="header-toystory__concept__video__layout">
          <div>
            <a
              className="header-toystory__concept__video__container"
              data-fancybox="etc"
              href={`https://youtu.be/${videoId}`}
            >
              <iframe allow="autoplay" height="100%" src={videoSrc} title={title} width="100%" />
            </a>
          </div>
        </div>
      </section>

      <section className="header-toystory__nav">
        <div className="base-toystory__container header-toystory__nav__container">
          <figure className="header-toystory__nav__top-icon">
            <img alt="rocket" src={`${baseImgUrl}/lineup/nav/nav-top-icon.webp`} />
          </figure>

          {renderAnimationHeader('LINEUP')}

          <ul className="header-toystory__nav__layout__list">
            {NAV_ITEMS.map(({ key, delay, scrollTargets, images, href, showTag }, index) => (
              <li
                key={key}
                className="header-toystory__nav__layout__item"
                data-aos="fade-up"
                data-aos-delay={delay}
                data-aos-duration="1000"
                data-key={key}
                {...(!href &&
                  scrollTargets?.length === 1 && {
                    onClick: () => scrollToSection(scrollTargets[0]),
                  })}
              >
                {href ? (
                  <a href={href}>
                    <div className="header-toystory__nav__item-header" data-key={key}></div>
                    <div className="header-toystory__nav__item-option-box" data-key={key}>
                      {images.map((img, i) => (
                        <div key={i} className="header-toystory__nav__item-option-img">
                          <img alt="" src={`${baseImgUrl}/lineup/nav/${img}`} />
                        </div>
                      ))}
                    </div>
                  </a>
                ) : (
                  <>
                    <div className="header-toystory__nav__item-header" data-key={key}></div>
                    <div className="header-toystory__nav__item-option-box" data-key={key}>
                      {images.map((img, i) => (
                        <div
                          key={i}
                          className="header-toystory__nav__item-option-img"
                          onClick={() => scrollTargets[i] && scrollToSection(scrollTargets[i])}
                        >
                          {showTag && i === 0 && (
                            <p className="header-toystory__nav__item-option-tag">
                              <span>
                                2WAY <br />
                                GLASSES
                              </span>
                            </p>
                          )}
                          <img alt="" src={`${baseImgUrl}/lineup/nav/${img}`} />
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </Fragment>
  );
};
